/**
 * Aviso de gracias al suscribirse a la newsletter.
 *
 * HISTORIAL. Aquí se han probado tres caminos y conviene no repetir los dos primeros:
 *
 *  Intento 1 (27 oct 2026): interceptar el submit y enviar por fetch, con el hCaptcha de
 *  Shopify todavía activado. NO FUNCIONABA: el token del captcha no viaja en un fetch hecho
 *  a mano, Shopify rechazaba el envío y el formulario acababa yéndose por el camino nativo
 *  igualmente.
 *
 *  Intento 2 (27 oct 2026): quitar el hCaptcha de Preferencias y volver al fetch. Tampoco.
 *  Sin la navegación del navegador, la petición pierde las señales de "esto lo ha hecho una
 *  persona pulsando un botón" y la protección antiabuso de Shopify mandaba al cliente a la
 *  página /challenge ("indícanos que no eres un robot"). Esa página NO se puede desactivar
 *  desde el admin: es de la plataforma, no del tema. Fran se la comió en pantalla.
 *
 *  Intento 3 (ESTE): no se toca el envío. El formulario se manda como siempre, el navegador
 *  navega de verdad y Shopify no sospecha nada. Lo que hacemos es:
 *
 *    - Guardar la posición del scroll justo antes de enviar.
 *    - Al volver con ?customer_posted=true, devolver la página a esa posición ANTES de
 *      pintar nada, y enseñar el aviso centrado.
 *
 *  Resultado: el cliente no nota la recarga, no salta arriba del todo, y no hay captcha ni
 *  challenge por medio. Es menos elegante por dentro que el fetch, pero es el único que
 *  aguanta en producción.
 *
 *  Intento 4 (la pieza que faltaba): el /challenge seguía saliendo a todo el mundo, también
 *  en móvil y en incógnito. La causa era que el hCaptcha no llegaba a engancharse a este
 *  formulario (vive en el pie, que el tema monta tarde), así que el envío salía sin token.
 *  Se arregla en el Liquid con data-shopify-captcha: "true". De paso se quitó el campo
 *  señuelo antibots, que era el otro sospechoso. Ver sections/kotashi-footer.liquid.
 *
 * REGLA: este script NO debe tocar el envío ni añadir campos al formulario. Solo scroll
 * y aviso. Cada vez que se ha intentado otra cosa, ha acabado en la página /challenge.
 *
 * 29 oct 2026: al apuntarse ya no se devuelve al cliente al pie, se le lleva a la sección
 * de los tres modelos (#comprar) y el botón del aviso dice "Elegir mi Mizu". La idea es
 * que el alta en la newsletter termine delante del producto y no en el pie de página.
 *
 * Sobre el parpadeo de /challenge que se ve al enviar: es la comprobación invisible de
 * Shopify, que pasa por esa URL y vuelve sola. No se puede quitar desde aquí ni desde los
 * ajustes; es servidor de Shopify. Si llegara a molestar de verdad, el plan B es montar
 * la captación con la app Shopify Forms, que no usa este formulario del tema.
 *
 * El código de descuento NO se muestra a propósito (decisión de Fran, 27 oct 2026): se manda
 * por correo, que es lo que empuja al cliente a abrir el email y deja la lista con
 * direcciones de verdad. El aviso solo confirma y le dice que lo revise.
 */
(() => {
  if (window.__kotashiNewsletterInit) return;
  window.__kotashiNewsletterInit = true;

  const CLAVE_SCROLL = 'kotashi:news:scroll';
  // Marca que sobrevive al salto a la ficha del producto para pintar allí el aviso.
  const CLAVE_GRACIAS = 'kotashi:news:gracias';

  const estilos = `
    .kotashi-gracias{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;
      justify-content:center;padding:20px;background:rgb(17 17 17 / .55);
      opacity:0;transition:opacity 220ms ease;backdrop-filter:blur(3px)}
    .kotashi-gracias.is-visible{opacity:1}
    .kotashi-gracias__caja{position:relative;max-width:420px;width:100%;background:#FAF8F3;
      color:#111;border-radius:18px;padding:40px 32px 32px;text-align:center;
      box-shadow:0 24px 60px rgb(0 0 0 / .28);transform:translateY(12px) scale(.98);
      transition:transform 260ms cubic-bezier(.2,.8,.3,1)}
    .kotashi-gracias.is-visible .kotashi-gracias__caja{transform:none}
    .kotashi-gracias__cerrar{position:absolute;top:12px;right:14px;border:0;background:none;
      font-size:26px;line-height:1;cursor:pointer;color:#111;opacity:.45;padding:4px}
    .kotashi-gracias__cerrar:hover{opacity:1}
    .kotashi-gracias__titulo{margin:0 0 10px;font-size:23px;line-height:1.25;font-weight:700}
    .kotashi-gracias__texto{margin:0 0 20px;font-size:15px;line-height:1.6;opacity:.78}
    .kotashi-gracias__lema{margin:0;font-size:12px;font-style:italic;opacity:.45}
    .kotashi-gracias__boton{display:inline-block;width:100%;box-sizing:border-box;border:0;
      border-radius:999px;padding:14px 20px;background:#111;color:#FAF8F3;font-size:15px;
      cursor:pointer;margin-bottom:18px;text-align:center;text-decoration:none;
      font-family:inherit;line-height:1.2}
    .kotashi-gracias__boton:hover{opacity:.88}
  `;

  const inyectarEstilos = () => {
    if (document.getElementById('kotashi-gracias-css')) return;
    const s = document.createElement('style');
    s.id = 'kotashi-gracias-css';
    s.textContent = estilos;
    document.head.appendChild(s);
  };

  const cerrar = (capa) => {
    capa.classList.remove('is-visible');
    setTimeout(() => capa.remove(), 240);
  };

  /**
   * A dónde mandar al cliente después de apuntarse. Lo pone el Liquid del pie en un
   * data- del propio <script>, así aquí no hay ninguna URL escrita a mano.
   */
  const destinoTrasAlta = () => {
    const s = document.currentScript
      || document.querySelector('script[data-kotashi-destino]');
    return (s && s.dataset.kotashiDestino) || '/#comprar';
  };

  const mostrar = ({ titulo, texto, accion }) => {
    inyectarEstilos();
    const capa = document.createElement('div');
    capa.className = 'kotashi-gracias';
    capa.setAttribute('role', 'dialog');
    capa.setAttribute('aria-modal', 'true');
    const boton = accion && accion.href
      ? `<a class="kotashi-gracias__boton" href="${accion.href}">${accion.texto}</a>`
      : `<button class="kotashi-gracias__boton">${(accion && accion.texto) || 'Seguir mirando'}</button>`;

    capa.innerHTML = `
      <div class="kotashi-gracias__caja">
        <button class="kotashi-gracias__cerrar" aria-label="Cerrar">&times;</button>
        <h2 class="kotashi-gracias__titulo">${titulo}</h2>
        <p class="kotashi-gracias__texto">${texto}</p>
        ${boton}
        <p class="kotashi-gracias__lema">quiet objects for loud little animals.</p>
      </div>`;
    document.body.appendChild(capa);
    requestAnimationFrame(() => capa.classList.add('is-visible'));

    capa.querySelector('.kotashi-gracias__cerrar').addEventListener('click', () => cerrar(capa));
    if (!(accion && accion.href)) {
      capa.querySelector('.kotashi-gracias__boton').addEventListener('click', () => cerrar(capa));
    }
    capa.addEventListener('click', (e) => { if (e.target === capa) cerrar(capa); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { cerrar(capa); document.removeEventListener('keydown', esc); }
    });
  };

  /**
   * Aviso de éxito. Antes de pintarlo intenta llevar la página a la sección de los tres
   * modelos, para que al cerrar el aviso el cliente ya esté delante del producto. Si esa
   * sección no existe aquí, el botón se convierte en un enlace a la home.
   */
  const avisoExito = () => mostrar({
    titulo: 'Gracias por confiar en KOTASHI',
    texto: 'Ya estás dentro. Te hemos mandado un correo con tu <strong>10&nbsp;% de descuento</strong> para tu primera Mizu. Si no lo ves en un par de minutos, míralo en <strong>Promociones</strong> o en la carpeta de spam: a veces se cuela ahí.',
    accion: { texto: 'Ver la Mizu' },
  });

  const avisoError = (detalle) => mostrar({
    titulo: 'No hemos podido apuntarte',
    texto: (detalle || 'Algo ha fallado por nuestro lado.') + ' Revisa el correo e inténtalo otra vez.',
  });

  const limpiarUrl = () => {
    try {
      const u = new URL(window.location.href);
      u.searchParams.delete('customer_posted');
      u.hash = '';
      window.history.replaceState({}, '', u.pathname + (u.search || ''));
    } catch (e) { /* da igual, es solo cosmético */ }
  };

  /**
   * Devuelve la página al punto donde estaba el cliente antes de enviar.
   *
   * Se hace en tres pasadas a propósito: la primera para que no se vea el salto, y dos más
   * en diferido porque el tema monta secciones (imágenes, fuentes) después de este script y
   * la altura de la página cambia justo después de cargar.
   */
  const recuperarScroll = () => {
    let y = null;
    try {
      const guardado = sessionStorage.getItem(CLAVE_SCROLL);
      if (guardado !== null) y = parseInt(guardado, 10);
      sessionStorage.removeItem(CLAVE_SCROLL);
    } catch (e) { /* navegación privada y similares: se queda arriba, sin más */ }

    if (y === null || Number.isNaN(y)) return;

    // Evita que el navegador imponga su propia restauración encima de la nuestra.
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

    const ir = () => window.scrollTo({ top: y, behavior: 'instant' in window ? 'instant' : 'auto' });
    ir();
    requestAnimationFrame(ir);
    setTimeout(ir, 250);
  };

  const engancharFormularios = () => {
    document.querySelectorAll('.kotashi-footer__form').forEach((form) => {
      if (form.dataset.kotashiEnganchado) return;
      form.dataset.kotashiEnganchado = '1';

      form.addEventListener('submit', () => {
        // Este script NO toca el envío. El formulario se manda de forma NATIVA para que
        // el token del hCaptcha viaje con él (ver cabecera del archivo). Lo único que
        // hace es apuntar dónde estaba mirando el cliente, para devolverlo ahí al volver.
        try {
          sessionStorage.setItem(CLAVE_SCROLL, String(window.scrollY || window.pageYOffset || 0));
        } catch (err) { /* sin sessionStorage simplemente volverá arriba */ }
      });
    });
  };

  const arrancar = () => {
    engancharFormularios();

    const params = new URLSearchParams(window.location.search);

    // Alta correcta. Aquí NO se recupera el scroll: queremos llevarle a la ficha del
    // producto, no devolverle al pie de donde estaba.
    if (params.get('customer_posted') === 'true') {
      try { sessionStorage.removeItem(CLAVE_SCROLL); } catch (e) { /* da igual */ }

      const destino = destinoTrasAlta();
      const yaEstoyAlli = (() => {
        try {
          return new URL(destino, window.location.origin).pathname === window.location.pathname;
        } catch (e) {
          return true; // ante la duda, no redirigir: mejor el aviso aquí que un salto raro
        }
      })();

      if (yaEstoyAlli) {
        avisoExito();
        limpiarUrl();
        return;
      }

      // Nos vamos a la ficha. El aviso tiene que sobrevivir al salto, así que se deja
      // una marca en sessionStorage y se pinta al llegar (ver más abajo). Se usa
      // replace() y no href= para que el botón "atrás" no devuelva al cliente a la URL
      // del ?customer_posted=true y le vuelva a salir el aviso.
      try { sessionStorage.setItem(CLAVE_GRACIAS, '1'); } catch (e) { /* ver nota */ }
      window.location.replace(destino);
      return;
    }

    // Venimos del salto de arriba: toca enseñar el aviso ya en la ficha del producto.
    let pendiente = null;
    try {
      pendiente = sessionStorage.getItem(CLAVE_GRACIAS);
      sessionStorage.removeItem(CLAVE_GRACIAS);
    } catch (e) { /* sin sessionStorage simplemente no sale el aviso, el alta sí se hizo */ }

    if (pendiente === '1') {
      avisoExito();
      return;
    }

    // Si Shopify ha devuelto un error de validación (correo mal escrito, por ejemplo),
    // lo pinta en el pie. Lo subimos al aviso centrado para que no quede fuera de vista.
    const error = document.querySelector('.kotashi-footer__form .kotashi-footer__aviso[role="alert"]');
    if (error && error.textContent.trim()) {
      recuperarScroll();
      avisoError(error.textContent.trim());
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
